module.exports = __webpack_public_path__ + "img/01-南天湖.4a627fca.jpg";